import request, {
  handleResponse,
  handleThenable,
  handleError,
  headers,
} from "./index";

// import { login_data, mock_data } from './mock'

// 注册
export const register = (params: {
  pass_hash: string;
  phone: string;
  phone_area: string;
  code: string;
  invite_code?: string;
}) => {
  // return mock_data(login_data, 2000).then(handleThenable).catch(handleError)
  return request
    .post("/api/auth/register", params)
    .then(handleResponse)
    .then(handleThenable)
    .catch(handleError);
};

// 密码登录
export const passwordLogin = (params: {
  pass_hash: string;
  phone: string;
  phone_area: string;
}) => {
  // return mock_data(login_data, 2000).then(handleThenable).catch(handleError)
  return request
    .post("/api/auth/login/hash", params)
    .then(handleResponse)
    .then(handleThenable)
    .catch(handleError);
};

// 验证码登陆
export const codeLogin = (params: {
  code: string;
  phone: string;
  phone_area: string;
}) => {
  // return mock_data(login_data, 2000).then(handleThenable).catch(handleError)
  return request
    .post("/api/auth/login/phone/code", params)
    .then(handleResponse)
    .then(handleThenable)
    .catch(handleError);
};

// 重制登陆
export const resetLogin = (params: {
  pass_hash: string;
  phone: string;
  phone_area: string;
  code: string;
}) => {
  // return mock_data(login_data, 2000).then(handleThenable).catch(handleError)
  return request
    .post("/api/auth/forget/phone", params)
    .then(handleResponse)
    .then(handleThenable)
    .catch(handleError);
};

// 退出登录
export const logout = () => {
  // return mock_data(login_data, 2000).then(handleThenable).catch(handleError)
  return request
    .post(
      "/api/auth/logout",
      {},
      {
        headers,
      }
    )
    .then(handleResponse)
    .then(handleThenable)
    .catch(handleError);
};
// 获取验证码
export const getCode = (params: { phone_area: string; phone: string }) => {
  // return mock_data(login_data, 2000).then(handleThenable).catch(handleError)
  return request
    .post("/api/auth/phone/code", params)
    .then(handleResponse)
    .then(handleThenable)
    .catch(handleError);
};

// 设置邮箱地址
export const bindEmail = (params: { email: string; code: string }) => {
  return request
    .post("/api/user/setting/email/verify", params, {
      headers,
    })
    .then(handleResponse)
    .then(handleThenable)
    .catch(handleError);
};

// 邮箱验证码
export const getEmailCode = (params: { email: string }) => {
  return request
    .post("/api/user/setting/email/code", params, {
      headers,
    })
    .then(handleResponse)
    .then(handleThenable)
    .catch(handleError);
};

// 绑定手机号
export const bindPhone = (params: {
  phone: string;
  code: string;
  // password: string;
}) => {
  return request
    .post("/api/user/setting/phone/verify", params, {
      headers,
    })
    .then(handleResponse)
    .then(handleThenable)
    .catch(handleError);
};
